import { render, staticRenderFns } from "./companyArchive.vue?vue&type=template&id=06b49cb6&"
import script from "./companyArchive.vue?vue&type=script&lang=js&"
export * from "./companyArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports